<div
  class="hero-course d-flex justify-content-center align-items-center"
  [ngStyle]="{ 'background-image': bgImg, 'background-color': bgColor }"
>
  <div class="container">
    <h1
      class="hero-course-title blue-50 text-center bold"
      [ngStyle]="{ color: txtColor }"
      [ngClass]="specialClass ? 'sc' : ''"
    >
      {{ pageTitle }}
    </h1>
    <div class="row divider p-4"></div>
    <div class="row mt-5 text-center">
      <img
        src="assets/img/scroll-down-corsi.svg"
        class="scroll-down m-auto mt-5"
        (click)="scrollDown()"
        alt="courses"
       
      />
    </div>
  </div>
</div>
